import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";

export default function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blogs").then((r) => setBlogs(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-[72px]" data-testid="blog-list-page">
      <SEO
        title="Legal Insights — Advocate Shubham Makkar | Corporate Law Blog"
        description="Plain-English articles on bail, anticipatory bail, FIR quashing and corporate procedure in India, by Advocate Shubham Makkar."
        keywords="corporate law blog, bail articles, anticipatory bail guide, indian corporate lawyer blog"
      />

      <section className="relative bg-gradient-to-b from-[#EFF6FF] to-white overflow-hidden">
        <div className="absolute inset-0 dot-grid opacity-30" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-12">
          <div className="inline-flex items-center gap-2 bg-white border border-blue-100 shadow-sm px-4 py-2 rounded-full mb-6">
            <span className="w-1.5 h-1.5 bg-[#1D4ED8] rounded-full"></span>
            <span className="text-xs tracking-wider text-[#1D4ED8] font-medium">Insights</span>
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#0A2540] tracking-tight leading-[1.05] max-w-4xl">
            Plain-English legal writing, <span className="italic text-[#1D4ED8]">from the counsel himself</span>.
          </h1>
        </div>
      </section>

      <section className="py-20 bg-slate-50/50">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          {loading && <div className="text-slate-500">Loading…</div>}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogs.map((b) => (
              <Link
                to={`/blog/${b.slug}`}
                key={b.id}
                className="group card-elevated overflow-hidden"
                data-testid={`blog-card-${b.slug}`}
              >
                {b.cover_image && (
                  <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                    <img
                      src={b.cover_image}
                      alt={b.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                )}
                <div className="p-6">
                  <div className="text-[10px] uppercase tracking-[0.18em] font-semibold text-[#1D4ED8] mb-3">
                    {new Date(b.created_at).toLocaleDateString("en-IN", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </div>
                  <h2 className="font-serif text-xl text-[#0A2540] leading-snug mb-3 font-semibold group-hover:text-[#1D4ED8] transition-colors">
                    {b.title}
                  </h2>
                  <p className="text-sm text-slate-600 leading-relaxed">{b.excerpt}</p>
                  <div className="mt-5 text-sm text-[#1D4ED8] inline-flex items-center gap-2 font-medium">
                    Read article <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
          {!loading && blogs.length === 0 && (
            <div className="text-slate-500 text-center py-16">
              No insights published yet. Check back soon.
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
